<form [formGroup]="form">
	<ngb-datepicker
		#dp
		[formControlName]="name"
		[minDate]="today"
		[firstDayOfWeek]="7"
		[markDisabled]="isDisabled"
		(dateSelect)="dateSelected($event)"
	>
	</ngb-datepicker>
</form>
